














































import { defineComponent, ref } from '@nuxtjs/composition-api'
import { useConsent } from '~/compositions/consent'

export default defineComponent({
  setup() {
    const { confirmOver18, confirmUnder18 } = useConsent()
    const loading = ref(false)

    async function onOver18ButtonClick() {
      loading.value = true
      await confirmOver18()
      loading.value = false
    }

    async function onUnder18ButtonClick() {
      loading.value = true
      await confirmUnder18()
      loading.value = false

      window.location.href = '/quick-search/xyma'
    }

    return { loading, onOver18ButtonClick, onUnder18ButtonClick }
  }
})
